import store from '@/store';
import router from '@/router';
export default function (error) {
    var _a, _b;
    // Retrieve response status
    // Check if action is unauthorized
    var status = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : null;
    var check = status === 401;
    // Dispatch logout action with store
    // This results in the user being logged out
    if (check) {
        store.dispatch('auth/lockout');
        router.push({ name: 'login' });
    }
    // Return response
    return Promise.reject(error);
}
